import './datasift_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.TwitterContentView extends Monitoring.Views.SocialContents.DatasiftContentView
  tagName: "section"
  className: "content tweet"
